<div class="chat-container" *ngIf="showProjects">
  <div class="projects-grid">
    <div class="project-header">
      <div class="header-content">
        <h2>Select a Project</h2>
        <div class="new-messages-badge" *ngIf="getUnreadMessages">
          <i class="notification-icon"></i>
          <span>You have new messages</span>
        </div>
      </div>
    </div>
    <div class="projects-list" *ngIf="!hasNoProjects">
      <div class="card" *ngFor="let project of projects" (click)="selectProject(project)">
        <div class="card-img-container">
          <img [src]="project.imageUrl" class="card-img-top" alt="{{ project.title }}">
        </div>
        <div class="card-body">
          <div class="card-btn">
            <div class="card-text">
              <div class="project-header">
                <span class="project-title">{{ project.title }}</span>

                <div class="unread-badge" *ngIf="project.containsUnreadMessages">
                  <i class="notification-icon"></i>
                </div>
              </div>

              <p class="project-description">{{ project.description }}</p>
              <div class="project-meta">
                <span class="creator" *ngIf="isAdmin">Created by: {{ project.creatorId }}</span>
              </div>
              <!--<div class="project-tags" *ngIf="project.tags?.length">
                <span class="tag" *ngFor="let tag of project.tags">{{ tag }}</span>
              </div>-->
              <div class="project-status-container">
                <div class="project-status" [ngClass]="{
                  'status-new': project.status === 'NEW',
                  'status-in-progress': project.status === 'IN_PROGRESS',
                  'status-completed': project.status === 'COMPLETED',
                  'status-archived': project.status === 'ARCHIVED'
                }">
                  <i class="status-icon"></i>
                  <span>{{ project.status | titlecase }}</span>
                </div>

                <button *ngIf="isAdmin && project.status !== 'ARCHIVED'"
                        class="archive-btn"
                        (click)="archiveProject(project, $event)"
                        title="Archive Project">
                  <i class="archive-icon"></i>
                  Archive
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-projects-message" *ngIf="hasNoProjects">
      <div class="alert">
        <div class="message-content">
          <div class="icon">📩</div>
          <h3 class="title">No Projects Available</h3>
          <p class="description">You will be able to see a project after you are assigned to one</p>
        </div>
      </div>
    </div>
  </div>
</div>
